import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect } from "react";
import Typography from '@mui/material/Typography';
import { useForm, FormContainer, FormErrorProvider } from "react-hook-form-mui";
import { useTheme } from "@mui/material";
import { useI18N } from "../../context/I18NContext";
import { CustomTextFieldElement } from "../../layouts/Theme";
export default function Contact(props) {
    const { t } = useI18N();
    const theme = useTheme();
    const formContext = useForm({});
    const onSubmit = (data, event) => {
    };
    const onError = (errors) => {
    };
    useEffect(() => {
        formContext.setValue('firstName', "Ricardo");
        formContext.setValue('lastName', "Matters");
        formContext.setValue('email', "ricardo.matters@gmail.com");
        formContext.setValue('phone', "06-23231588");
    }, []);
    return (_jsx(_Fragment, { children: _jsx(FormContainer, { formContext: formContext, onSuccess: onSubmit, onError: onError, children: _jsxs(FormErrorProvider, { onError: (error) => {
                    if (error.type === 'validate') {
                        console.log(error);
                    }
                    return t(error.type, 'error');
                }, children: [_jsx(Typography, { variant: "h6", sx: { color: theme.palette.text.primary, marginLeft: 1, marginTop: 2, marginBottom: 1 }, children: t(props.label) }), _jsx(CustomTextFieldElement, { required: true, label: t('Voornaam'), name: 'firstName', type: "input", sx: { my: 1 }, fullWidth: true }), _jsx(CustomTextFieldElement, { required: true, label: t('Achternaam'), name: 'lastName', type: "input", sx: { my: 1 }, fullWidth: true }), _jsx(CustomTextFieldElement, { required: true, label: t('E-mailadres'), name: 'email', type: "email", sx: { my: 1 }, fullWidth: true })] }) }) }));
}
